import Masker from 'vue-the-mask/src/masker'
import Tokens from 'vue-the-mask/src/tokens'

export default {
    methods: {
        format(mask, value){
            return Masker(value, mask, true, Tokens);
        },
        validateEmail: (email) => {
            var regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regularExpression.test(String(email).toLowerCase());
        }
    }
}